module.exports = {
      id: "shortvideo-usage",
      viewBox: "0 0 15 19",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#shortvideo",
      toString: function () {
        return this.url;
      }
    }